var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep8Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "deal",
    clipPath: "url(#clip0_309_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_309_144",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 54
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath3935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3933",
    d: "M0 7.62939e-06H54V54H0V7.62939e-06Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_309_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3937"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3939",
    d: "M32.2206 27.8281C27.937 28.3607 23.9213 30.2902 20.8161 33.3528L20.2231 33.9377C19.3007 34.8474 19.283 36.3301 20.1834 37.2615C20.85 37.9512 21.8673 38.1693 22.758 37.8137L27.5485 35.9007H33.3023",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3941"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3943",
    d: "M28.3223 45.0536L32.2911 48.8944C33.0928 49.6736 34.3744 49.6553 35.1536 48.8536C35.9328 48.0518 35.9144 46.7701 35.1127 45.9909L29.1905 40.1968",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3947",
    d: "M28.3553 50.7489C29.1571 51.5281 30.4386 51.5098 31.2178 50.708C31.997 49.9063 31.9787 48.6247 31.177 47.8455L26.6318 43.4283",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3949"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3951",
    d: "M35.2114 46.0541C36.0131 46.8333 37.2947 46.8149 38.0739 46.0132C38.8531 45.2115 38.8347 43.9298 38.0331 43.1506L30.6572 36.0181",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3953"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3955",
    d: "M15.7669 45.2149C14.9528 44.5443 14.8364 43.3407 15.5071 42.5266L16.2192 41.662C16.8899 40.8479 18.0934 40.7317 18.9075 41.4023C19.7216 42.0728 19.838 43.2764 19.1673 44.0906L18.4552 44.9551C17.7846 45.7692 16.581 45.8854 15.7669 45.2149Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3959",
    d: "M18.7151 47.6436C17.901 46.973 17.7847 45.7694 18.4554 44.9553L19.1675 44.0907C19.8382 43.2766 21.0417 43.1604 21.8558 43.831C22.6699 44.5016 22.7862 45.7052 22.1155 46.5193L21.4034 47.3838C20.7328 48.1979 19.5292 48.3141 18.7151 47.6436Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3963",
    d: "M21.6634 50.072C20.8492 49.4015 20.7329 48.1979 21.4036 47.3837L22.1157 46.5192C22.7864 45.7051 23.9899 45.5889 24.804 46.2594C25.6181 46.93 25.7345 48.1336 25.0638 48.9477L24.3517 49.8123C23.6811 50.6264 22.4775 50.7426 21.6634 50.072Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3967",
    d: "M24.6106 52.5005C23.7965 51.8299 23.6802 50.6263 24.3509 49.8122L25.063 48.9477C25.7337 48.1336 26.9372 48.0173 27.7513 48.6879C28.5654 49.3585 28.6817 50.5621 28.011 51.3762L27.2989 52.2407C26.6284 53.0548 25.4247 53.1711 24.6106 52.5005Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3971",
    d: "M37.6738 42.6936L41.8853 38.4821",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3973"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3975",
    d: "M15.465 42.4165L11.8682 38.8197",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3977"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3979",
    d: "M20.7441 28.6949C21.3845 29.3492 22.2615 29.718 23.1771 29.718H25.92",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3983",
    d: "M22.3911 27.0481L9.86447 39.5747L6.09375 35.804L18.6204 23.2774L22.3911 27.0481Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3985"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3987",
    d: "M6.96107 34.5886L1.05566 28.6832",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3989"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3991",
    d: "M17.4889 24.4092L1.06152 7.98179",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3995",
    d: "M31.6084 27.0481L44.135 39.5747L47.9057 35.804L35.3791 23.2774L31.6084 27.0481Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3997"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3999",
    d: "M47.0391 34.5886L52.9445 28.6832",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4007",
    d: "M36.5107 24.4092L49.9873 10.9326",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4009"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4011",
    d: "M24.6953 12.898C24.6953 14.053 25.727 14.9893 26.9996 14.9893C28.2722 14.9893 29.3039 14.053 29.3039 12.898C29.3039 11.743 28.2722 10.8068 26.9996 10.8068",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4015",
    d: "M26.9996 10.8066C25.727 10.8066 24.6953 9.87039 24.6953 8.71541C24.6953 7.56042 25.727 6.62417 26.9996 6.62417C28.2722 6.62417 29.3039 7.56042 29.3039 8.71541",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4017"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4019",
    d: "M27 5.67431V6.62427",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4021"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4023",
    d: "M27 15.094V15.8591",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4025"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4027",
    d: "M36.7031 10.7666C36.7031 5.40774 32.3589 1.06348 27 1.06348C21.6411 1.06348 17.2969 5.40774 17.2969 10.7666C17.2969 16.1255 21.6411 20.4697 27 20.4697C32.3589 20.4697 36.7031 16.1255 36.7031 10.7666Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_309_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep8Icon);
export default __webpack_public_path__ + "static/media/step8-icon.e90b373038f1e6dabae95d02e32ee888.svg";
export { ForwardRef as ReactComponent };